import cn from 'classnames';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const PostSkipPencil = ({ className = '' }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <svg
      className={cn('icon', className)}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      pointerEvents="none"
    >
      <path
        d="M24 10.2502C26.0777 10.2502 28.0497 10.7118 29.8174 11.5383L29.5 12.218L29.1826 12.8967C27.6096 12.1612 25.8537 11.7502 24 11.7502C17.2345 11.7502 11.75 17.2348 11.75 24.0002C11.7501 30.7657 17.2346 36.2502 24 36.2502C30.7654 36.2502 36.2499 30.7657 36.25 24.0002C36.25 22.3261 35.9142 20.7321 35.3076 19.2805L36.6924 18.7024C37.3741 20.3338 37.75 22.1242 37.75 24.0002C37.7499 31.5941 31.5939 37.7502 24 37.7502C16.4061 37.7502 10.2501 31.5941 10.25 24.0002C10.25 16.4063 16.4061 10.2502 24 10.2502ZM36.2676 5.70728C36.6581 5.31675 37.2921 5.31675 37.6826 5.70728L42.6318 10.6565C43.0224 11.047 43.0224 11.681 42.6318 12.0715L39.3643 15.3391L33 8.97485L36.2676 5.70728Z"
        fill={isTempo ? '#7fc1fb' : '#99CE99'}
      />
      <path
        d="M24 4.25C27.6405 4.25 31.0518 5.23774 33.9814 6.95703L35.6016 5.33789C36.285 4.65457 37.3928 4.65457 38.0762 5.33789L43.0264 10.2881C43.7094 10.9715 43.7096 12.0794 43.0264 12.7627L41.3066 14.4814C42.8628 17.3053 43.75 20.55 43.75 24C43.75 34.9076 34.9076 43.75 24 43.75C13.0924 43.75 4.25 34.9076 4.25 24C4.25 13.0924 13.0924 4.25 24 4.25ZM24 5.75C13.9208 5.75 5.75 13.9208 5.75 24C5.75 34.0792 13.9208 42.25 24 42.25C34.0792 42.25 42.25 34.0792 42.25 24C42.25 20.9652 41.5076 18.1063 40.1982 15.5898L29.752 26.0371C29.6503 26.1385 29.5211 26.2088 29.3809 26.2393L22.0098 27.8418C21.1207 28.0351 20.3293 27.2436 20.5225 26.3545L22.125 18.9824C22.1555 18.8423 22.2259 18.7138 22.3271 18.6123L32.8828 8.05566C30.2543 6.588 27.2262 5.75 24 5.75ZM22.415 24.709L23.6543 25.9482L27.7207 25.0654L23.2988 20.6426L22.415 24.709ZM28.1611 23.3848L29.2227 24.4453L38.167 15.5L37.1064 14.4395L28.1611 23.3848ZM26.04 21.2627L27.1006 22.3232L36.0459 13.3789L34.9854 12.3174L26.04 21.2627ZM23.9189 19.1416L24.9795 20.2021L33.9248 11.2568L32.8643 10.1963L23.9189 19.1416ZM37.0156 6.39844C36.918 6.30091 36.7597 6.30091 36.6621 6.39844L33.9248 9.13574L39.2285 14.4395L41.9658 11.7021C42.0633 11.6046 42.0631 11.4463 41.9658 11.3486L37.0156 6.39844Z"
        fill={isTempo ? '#2b2b2b' : '#004400'}
      />
    </svg>
  );
};

PostSkipPencil.propTypes = {
  className: PropTypes.string,
};

export default PostSkipPencil;
